import {
  prefetchCategoryPromotion,
  prefetchPage,
  prefetchTranslation,
  prefetchModalWindowTranslation,
  prefetchInlineBanners,
} from '@Navigation/prefetchers';
import { prefetchInfiniteCategory } from '@Queries/useInfiniteCategory';

import type { LoaderFn } from '@Types/Router';

export const loader: LoaderFn = (deps) => async (args) => {
  const { queryClient } = deps;
  const { request, params } = args;
  const { page = '', slug } = params;
  const { search } = new URL(request.url);
  const pageNumber = parseInt(page.replace(/\D/g, ''), 10) || 1;

  return Promise.all([
    prefetchCategoryPromotion({ slug }, queryClient),
    prefetchInfiniteCategory({ slug, pageNumber, search }, queryClient),
    prefetchPage(request.url, queryClient),
    prefetchTranslation(request.url, queryClient),
    prefetchModalWindowTranslation('Filters', queryClient),
    prefetchInlineBanners({ queryClient, slug, search }),
  ]);
};
